import angular from 'angular';

const debounce = /* @ngInject */ ($timeout, $q) => (function_, wait, immediate) => {
	let timeout;
	// Create a deferred object that will be resolved when we need to
	// actually call the func
	let deferred = $q.defer();

	return (...arguments_) => {
		const later = () => {
			timeout = null;
			if (!immediate) {
				deferred.resolve(Reflect.apply(function_, this, arguments_));
				deferred = $q.defer();
			}
		};
		const callNow = immediate && !timeout;
		if (timeout) {
			$timeout.cancel(timeout);
		}
		timeout = $timeout(later, wait);
		if (callNow) {
			deferred.resolve(Reflect.apply(function_, this, arguments_));
			deferred = $q.defer();
		}
		return deferred.promise;
	};
};

angular.module('app')
	.factory('debounce', debounce);
